<app-header [hasAdminButton] = "true"></app-header>
<app-main></app-main>
